/* Copyright Verge Technologies 2018
 * @file articles.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component responsible for housing articles
 */

// Modules
import React from 'react';
import { Query } from 'react-apollo';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { ARTICLE_QUERY } from '../../graphql';

// Components

const Article = (props) => {
  return (
    <div className="applications-container">
      <Query query={ARTICLE_QUERY} fetchPolicy="cache-and-network" variables={{ slug: props.slug }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div>
              <div className="page-heading heading-articles">{data.getArticle.title}</div>
              <div className="page-content">
                <div className="content-image">
                  <img src="/images/article-page.jpg" alt="article" />
                </div>

                <div className="content">
                  <div className="details">
                    <span className="date">{new Date(data.getArticle.created_at).toDateString()}</span> &nbsp;{' '}
                    <span className="tags">
                      Tags: {data.getArticle.tags.map((tag, i) => <a href={null} key={i}>{tag}{i !== data.getArticle.tags.length - 1 ? ', ' : ' '}</a>)}
                      <span className="author">By {data.getArticle.author} </span>
                    </span>
                  </div>
                  <span>
                    {ReactHtmlParser(data.getArticle.body)}
                  </span>
                </div>
              </div>
            </div>
          );
        }}
      </Query>
    </div>
  );
};

Article.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default Article;



// WEBPACK FOOTER //
// ./src/components/Article/article.js